import {Injectable} from '@angular/core';
import {UuidService} from "./uuid.service";
declare var require: any;
const ThumbmarkJS = require('@thumbmarkjs/thumbmarkjs');
import {StorageService} from "./storage.service";
import {HashService} from "./hash.service";

@Injectable({
    providedIn: 'root'
})
export class FingerprintService {
  private readonly DB_KEY = 'sn_fingerprint_device_uuid';

  constructor(
    private uuidService: UuidService,
    private storageService: StorageService,
    private hashService: HashService
  ) {}

  async getFullIdentity() {
    try {
      const fpData = await ThumbmarkJS.getThumbmark();

      let deviceUuid = await this.storageService.read(this.DB_KEY);
      if (!deviceUuid) {
        deviceUuid = this.uuidService.generateUUID();

        await this.storageService.save(this.DB_KEY, deviceUuid);

        localStorage.setItem(this.DB_KEY, deviceUuid);
      }

      const comps = fpData && fpData.components ? fpData.components : {};

      let audioHash  = comps.audio  ? this.hashService.getParametersHash(comps.audio) : null;
      let mathHash   = comps.math   ? this.hashService.getParametersHash(comps.math)  : null;
      let webglHash  = comps.webgl  ? this.hashService.getParametersHash(comps.webgl) : null;
      let canvasHash = comps.canvas ? this.hashService.getParametersHash(comps.canvas): null;
      let screenHash = comps.screen ? this.hashService.getParametersHash(comps.screen): null;

      let timezone = (comps.locales && comps.locales.timezone) ? comps.locales.timezone : null;

      return {
        device_uuid: deviceUuid,
        hash: fpData ? this.hashService.getParametersHash(fpData.thumbmark) : null,
        math: mathHash,
        webgl: webglHash,
        canvas: canvasHash,
        audio: audioHash,
        screen: screenHash,
        timezone: timezone,
        isStandalone: window.matchMedia('(display-mode: standalone)').matches
      };
    } catch (error) {
      return localStorage.getItem(this.DB_KEY) || this.uuidService.generateUUID();
    }
  }

}
